'use client'

import Link from 'next/link'
import { useSyncExternalStore } from 'react'

interface FooterEmailLinkProps {
  email: string
  className?: string
  gaTrackingValue?: string
  gaTrackingLabel?: string
}

const emptySubscribe = () => () => {}

// Render email only after hydration so Cloudflare email obfuscation
// never sees the address in SSR HTML, preventing email-decode.min.js injection.
export function FooterEmailLink({
  email,
  className,
  gaTrackingValue,
  gaTrackingLabel,
}: FooterEmailLinkProps) {
  const isClient = useSyncExternalStore(
    emptySubscribe,
    () => true,
    () => false
  )

  if (!isClient) {
    return (
      <span className={className} aria-label='Email liên hệ'>
        {email.replace('@', '[@]')}
      </span>
    )
  }

  return (
    <Link
      href={`mailto:${email}`}
      className={className}
      ga-tracking-value={gaTrackingValue}
      ga-tracking-label={gaTrackingLabel}
    >
      {email}
    </Link>
  )
}
